import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteData,
  getData,
  getDataById,
  postData,
  postDataWithParams,
  updateData,
} from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getDebtMoney = createAsyncThunk(
  "farmer/debt-money",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData(
        "/farmer/debt-money",
        data.token,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDebtMoneyById = createAsyncThunk(
  "farmer/debt-money/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById(
        "/farmer/debt-money/",
        data.token,
        data.id
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortDebtMoney = createAsyncThunk(
  "farmer/debt-money/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/debt-money/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const postDebtMoney = createAsyncThunk(
  "farmer/debt-money/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/farmer/debt-money",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDebtMoney = createAsyncThunk(
  "farmer/debt-money/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData(
        "/farmer/debt-money/",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateDebtMoney = createAsyncThunk(
  "farmer/debt-money/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/debt-money/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const debtMoneySlice = createSlice({
  name: "Debt Money Store",
  initialState: initialState,
  reducers: {
    addDebtMoney(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortDebtMoney(state, action) {
      state.data.docs = action.payload;
    },
    deleteDebtMoney(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editDebtMoney(state, action) {
      let x = state.data.docs.findIndex(
        (item) => item._id === action.payload._id
      );
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getDebtMoney.pending]: (state) => {
      state.isLoading = true;
    },
    [getDebtMoney.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getDebtMoney.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDebtMoneyById.pending]: (state) => {
      state.isLoading = true;
    },
    [getDebtMoneyById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDebtMoneyById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDebtMoney.pending]: (state) => {
      state.isLoading = true;
    },
    [sortDebtMoney.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDebtMoney.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postDebtMoney.pending]: (state) => {
      state.isLoading = true;
    },
    [postDebtMoney.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postDebtMoney.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteDebtMoney.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteDebtMoney.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteDebtMoney.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateDebtMoney.pending]: (state) => {
      state.isLoading = true;
    },
    [updateDebtMoney.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateDebtMoney.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const debtMoneyActions = debtMoneySlice.actions;

export default debtMoneySlice.reducer;
